
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as go84_lcdpvSDv21V5haaHSPEuN_6GPZkNB3LjPz1Zf_45IMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexh04rkhkv73T_45RzQceDNY2c78XJTUEJ_4573xiqSudtkskMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchlFKzkWUE4K3_VGWDNCYVWieK0M8bMPxxwqjAQdydrxsMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexD6a2s0d4L9sTqs8YyCIi7Oil1lJ7OBI7RqTjDVQqCjUMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93itYTI2Cog8MHtli9CyG4atD4QLz_DHItqHo6ocsQmuIMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexlHKUdoDTZl_4Ng_gG2ZlteJPGMpwi4PjgqQHkqpfxJ4Meta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93eqrHaPT8tICvMBu11nPoK6_oC_45nDQylACLoY_45cjQi68Meta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexLinBsPBMxq8JumGCapV505VErWhmOH7HBkjjL3c3a00Meta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93P1v915gxLtHW0hw5ydXxJBlSEOOMY8ykPAskM4o7wBkMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexig4EfOGlegWveVC7CRrh18PvVfHxfhgPb8kiahVNBWUMeta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexhWKC77PCaydwB9LwjN2t03UCjwKqokF0cRAPqnltD_458Meta } from "/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexlHKUdoDTZl_4Ng_gG2ZlteJPGMpwi4PjgqQHkqpfxJ4Meta || {},
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexLinBsPBMxq8JumGCapV505VErWhmOH7HBkjjL3c3a00Meta || {},
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexig4EfOGlegWveVC7CRrh18PvVfHxfhgPb8kiahVNBWUMeta || {},
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexhWKC77PCaydwB9LwjN2t03UCjwKqokF0cRAPqnltD_458Meta || {},
    component: () => import("/codebuild/output/src3092891449/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]